export default {
  SET_FLIGHTS_REQUEST: 'SET_FLIGHTS_REQUEST',
  SET_FLIGHTS_SUCCESS: 'SET_FLIGHTS_SUCCESS',
  SET_FLIGHTS_FAILURE: 'SET_FLIGHTS_FAILURE',

  GET_FLIGHTS_REQUEST: 'GET_FLIGHTS_REQUEST',
  GET_FLIGHTS_SUCCESS: 'GET_FLIGHTS_SUCCESS',
  GET_FLIGHTS_FAILURE: 'GET_FLIGHTS_FAILURE',

  // local redux update
  UPDATE_FLIGHTS: 'UPDATE_FLIGHTS',
};



// WEBPACK FOOTER //
// ./src/redux/constants/FlightsConstants.js